import { useQuery } from "@tanstack/react-query"
import { apiFetch } from "../framework/api"
import { useAuthToken } from "./useAuthToken"

export type ResortMember = {
  uid: string
  name: string
}

export type ResortDetailData = {
  uid: string
  name: string
  liftCount: number
  runCount: number
  totalRunLengthMeters?: number
  isGroup: boolean
  members?: ResortMember[]
  geometry?: string
  convexHull?: string
}

export function useResort(uid?: string) {
  const token = useAuthToken()

  return useQuery({
    queryKey: ["resort", uid],
    queryFn: async () => {
      const data = await apiFetch<ResortDetailData>(`/admin/resorts/${uid}`, {
        token,
        method: "GET",
      })
      return data
    },
    enabled: Boolean(uid),
  })
}
